import React from 'react';
function SunIcon(){
    return(
        <svg width="21" height="21" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.54975 5.49049L4.66042 2.90976M4.057 8.89558L1 7.90983M4.057 13.1044L1 14.0902M6.54975 16.5095L4.66042 19.0902M10.5833 17.81V21M14.6169 16.5095L16.5062 19.0902M17.1097 13.1044L20.1667 14.0902M17.1097 8.89558L20.1667 7.90983M14.6169 5.49049L16.5062 2.90976M10.5833 4.18996V1M15.2566 11C15.2566 13.5614 13.1643 15.6379 10.5833 15.6379C8.00234 15.6379 5.91004 13.5614 5.91004 11C5.91004 8.43857 8.00234 6.36212 10.5833 6.36212C13.1643 6.36212 15.2566 8.43857 15.2566 11Z" stroke="#535252" strokeLinecap="round" />
        </svg>
    )
}

export default SunIcon;